export default __webpack_public_path__ + "static/media/pipe.bee17ef0.jpg";